import * as React from 'react';

type AnchorProps = React.ComponentPropsWithRef<'a'>;

export const Anchor: React.FC<AnchorProps> = ({ children, ...props }) => (
  <a {...props} rel={'noopener noreferrer'} target={'_blank'}>
    {children}
  </a>
);
